import { isChainPointerRow } from '@papan/types'

/**
 * Does a drive row carry the outbound "shared" badge on its icon? Any row that is
 * shared out (directly or by an ancestor — the inherited case fades the glyph), except
 * a LIVE `.chain`: a chain is a shortcut, never shared itself (Share on it is refused).
 *
 * LIVE = kind AND suffix — the ONE classifier (`isChainPointerRow`, I110). A chain renamed
 * off its suffix (`Super.chai`, still `file_type = 'chain'`) is a plain file and shows the
 * badge every other file in a shared folder shows; testing the kind alone dropped it.
 */
export function showsOutboundShareBadge(file: { name: string; fileType?: string | null; hasOutboundShare?: boolean }): boolean {
  return !!file.hasOutboundShare && !isChainPointerRow(file)
}
